module.exports = __webpack_public_path__ + "static/art5-c14e52fec1ec49938b06f7860b9d2846.jpg";